export default {
  "root": "_root_1h4a8_1",
  "--type-literal": "_--type-literal_1h4a8_1",
  "--type-unit": "_--type-unit_1h4a8_1",
  "--type-literal--m": "_--type-literal--m_1h4a8_1",
  "--type-unit--m": "_--type-unit--m_1h4a8_1",
  "--type-literal--l": "_--type-literal--l_1h4a8_1",
  "--type-unit--l": "_--type-unit--l_1h4a8_1",
  "--type-literal--xl": "_--type-literal--xl_1h4a8_1",
  "--type-unit--xl": "_--type-unit--xl_1h4a8_1"
};import "ni:sha-256;Y5OJUcRkDd6CYC41TzSaIsV0B8v5pUJeqxJE_T4FiEw";